/* eslint-disable */
import * as Types from '../../graphql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;

export const GetTariffPlansDocument = gql`
    query GetTariffPlans($period: TariffPeriod) {
  planPrice(period: $period) {
    planId
    planName
    uah
    eur
  }
}
    `;

/**
 * __useGetTariffPlansQuery__
 *
 * To run a query within a React component, call `useGetTariffPlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTariffPlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTariffPlansQuery({
 *   variables: {
 *      period: // value for 'period'
 *   },
 * });
 */
export function useGetTariffPlansQuery(baseOptions?: Apollo.QueryHookOptions<GetTariffPlansQuery, GetTariffPlansQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTariffPlansQuery, GetTariffPlansQueryVariables>(GetTariffPlansDocument, options);
      }
export function useGetTariffPlansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTariffPlansQuery, GetTariffPlansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTariffPlansQuery, GetTariffPlansQueryVariables>(GetTariffPlansDocument, options);
        }
export function useGetTariffPlansSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTariffPlansQuery, GetTariffPlansQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTariffPlansQuery, GetTariffPlansQueryVariables>(GetTariffPlansDocument, options);
        }
export type GetTariffPlansQueryHookResult = ReturnType<typeof useGetTariffPlansQuery>;
export type GetTariffPlansLazyQueryHookResult = ReturnType<typeof useGetTariffPlansLazyQuery>;
export type GetTariffPlansSuspenseQueryHookResult = ReturnType<typeof useGetTariffPlansSuspenseQuery>;
export type GetTariffPlansQueryResult = Apollo.QueryResult<GetTariffPlansQuery, GetTariffPlansQueryVariables>;
export const GetPaidFeaturesDocument = gql`
    query GetPaidFeatures($page: Int, $itemsPerPage: Int, $companyId: Int!) {
  user(companyId: $companyId) {
    id
    email
    company(id: $companyId) {
      id
      timeZone {
        id
        name
      }
      paidFeaturesPaginated(page: $page, itemsPerPage: $itemsPerPage) {
        currentPage
        itemsPerPage
        pageCount
        totalCount
        paidFeatures {
          id
          name
          status
          isYearly
          currency
          price
          subscriptionRegistrationDate
          dateOfLastPayment
          paymentOrdersByDate {
            id
            planId
            test
            amount
            currency
            createdAt
            status
            invoiceUrl
          }
          paymentOrder {
            id
            planId
            test
            invoiceUrl
            amount
            currency
            status
            createdAt
            paymentOrders {
              id
              planId
              invoiceUrl
              test
            }
          }
        }
      }
      paidFeatures {
        id
        name
        status
        isYearly
        currency
        price
        subscriptionRegistrationDate
        dateOfLastPayment
        paymentOrdersByDate {
          id
          planId
          test
          amount
          currency
          createdAt
          status
          invoiceUrl
        }
        paymentOrder {
          id
          planId
          test
          invoiceUrl
          amount
          currency
          status
          createdAt
          paymentOrders {
            id
            planId
            invoiceUrl
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetPaidFeaturesQuery__
 *
 * To run a query within a React component, call `useGetPaidFeaturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaidFeaturesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaidFeaturesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      itemsPerPage: // value for 'itemsPerPage'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetPaidFeaturesQuery(baseOptions: Apollo.QueryHookOptions<GetPaidFeaturesQuery, GetPaidFeaturesQueryVariables> & ({ variables: GetPaidFeaturesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaidFeaturesQuery, GetPaidFeaturesQueryVariables>(GetPaidFeaturesDocument, options);
      }
export function useGetPaidFeaturesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaidFeaturesQuery, GetPaidFeaturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaidFeaturesQuery, GetPaidFeaturesQueryVariables>(GetPaidFeaturesDocument, options);
        }
export function useGetPaidFeaturesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaidFeaturesQuery, GetPaidFeaturesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPaidFeaturesQuery, GetPaidFeaturesQueryVariables>(GetPaidFeaturesDocument, options);
        }
export type GetPaidFeaturesQueryHookResult = ReturnType<typeof useGetPaidFeaturesQuery>;
export type GetPaidFeaturesLazyQueryHookResult = ReturnType<typeof useGetPaidFeaturesLazyQuery>;
export type GetPaidFeaturesSuspenseQueryHookResult = ReturnType<typeof useGetPaidFeaturesSuspenseQuery>;
export type GetPaidFeaturesQueryResult = Apollo.QueryResult<GetPaidFeaturesQuery, GetPaidFeaturesQueryVariables>;
export const GetPaymentStatusDocument = gql`
    query GetPaymentStatus($companyId: Int!, $orderId: Int!) {
  user(companyId: $companyId) {
    id
    company(id: $companyId) {
      paymentOrders(id: $orderId) {
        status
        invoiceUrl
      }
    }
  }
}
    `;

/**
 * __useGetPaymentStatusQuery__
 *
 * To run a query within a React component, call `useGetPaymentStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentStatusQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useGetPaymentStatusQuery(baseOptions: Apollo.QueryHookOptions<GetPaymentStatusQuery, GetPaymentStatusQueryVariables> & ({ variables: GetPaymentStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentStatusQuery, GetPaymentStatusQueryVariables>(GetPaymentStatusDocument, options);
      }
export function useGetPaymentStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentStatusQuery, GetPaymentStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentStatusQuery, GetPaymentStatusQueryVariables>(GetPaymentStatusDocument, options);
        }
export function useGetPaymentStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaymentStatusQuery, GetPaymentStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPaymentStatusQuery, GetPaymentStatusQueryVariables>(GetPaymentStatusDocument, options);
        }
export type GetPaymentStatusQueryHookResult = ReturnType<typeof useGetPaymentStatusQuery>;
export type GetPaymentStatusLazyQueryHookResult = ReturnType<typeof useGetPaymentStatusLazyQuery>;
export type GetPaymentStatusSuspenseQueryHookResult = ReturnType<typeof useGetPaymentStatusSuspenseQuery>;
export type GetPaymentStatusQueryResult = Apollo.QueryResult<GetPaymentStatusQuery, GetPaymentStatusQueryVariables>;
export const GetPlanPriceDocument = gql`
    query GetPlanPrice {
  planPrice {
    planId
    planName
    eur
    uah
    usd
    savingsEur
    savingsUah
    savingsUsd
  }
}
    `;

/**
 * __useGetPlanPriceQuery__
 *
 * To run a query within a React component, call `useGetPlanPriceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlanPriceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlanPriceQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPlanPriceQuery(baseOptions?: Apollo.QueryHookOptions<GetPlanPriceQuery, GetPlanPriceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlanPriceQuery, GetPlanPriceQueryVariables>(GetPlanPriceDocument, options);
      }
export function useGetPlanPriceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlanPriceQuery, GetPlanPriceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlanPriceQuery, GetPlanPriceQueryVariables>(GetPlanPriceDocument, options);
        }
export function useGetPlanPriceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPlanPriceQuery, GetPlanPriceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPlanPriceQuery, GetPlanPriceQueryVariables>(GetPlanPriceDocument, options);
        }
export type GetPlanPriceQueryHookResult = ReturnType<typeof useGetPlanPriceQuery>;
export type GetPlanPriceLazyQueryHookResult = ReturnType<typeof useGetPlanPriceLazyQuery>;
export type GetPlanPriceSuspenseQueryHookResult = ReturnType<typeof useGetPlanPriceSuspenseQuery>;
export type GetPlanPriceQueryResult = Apollo.QueryResult<GetPlanPriceQuery, GetPlanPriceQueryVariables>;
export const GeneratePaymentUrlDocument = gql`
    mutation GeneratePaymentUrl($companyId: Int!, $input: GeneratePaymentUrlInput!, $branchId: Int!) {
  generatePaymentUrl(companyId: $companyId, input: $input, branchId: $branchId)
}
    `;
export type GeneratePaymentUrlMutationFn = Apollo.MutationFunction<GeneratePaymentUrlMutation, GeneratePaymentUrlMutationVariables>;

/**
 * __useGeneratePaymentUrlMutation__
 *
 * To run a mutation, you first call `useGeneratePaymentUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGeneratePaymentUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generatePaymentUrlMutation, { data, loading, error }] = useGeneratePaymentUrlMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      input: // value for 'input'
 *      branchId: // value for 'branchId'
 *   },
 * });
 */
export function useGeneratePaymentUrlMutation(baseOptions?: Apollo.MutationHookOptions<GeneratePaymentUrlMutation, GeneratePaymentUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GeneratePaymentUrlMutation, GeneratePaymentUrlMutationVariables>(GeneratePaymentUrlDocument, options);
      }
export type GeneratePaymentUrlMutationHookResult = ReturnType<typeof useGeneratePaymentUrlMutation>;
export type GeneratePaymentUrlMutationResult = Apollo.MutationResult<GeneratePaymentUrlMutation>;
export type GeneratePaymentUrlMutationOptions = Apollo.BaseMutationOptions<GeneratePaymentUrlMutation, GeneratePaymentUrlMutationVariables>;
export const GenerateManageUrlDocument = gql`
    mutation GenerateManageUrl($paidFeatureId: Int!, $branchId: Int!) {
  generateManageUrl(paidFeatureId: $paidFeatureId, branchId: $branchId)
}
    `;
export type GenerateManageUrlMutationFn = Apollo.MutationFunction<GenerateManageUrlMutation, GenerateManageUrlMutationVariables>;

/**
 * __useGenerateManageUrlMutation__
 *
 * To run a mutation, you first call `useGenerateManageUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateManageUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateManageUrlMutation, { data, loading, error }] = useGenerateManageUrlMutation({
 *   variables: {
 *      paidFeatureId: // value for 'paidFeatureId'
 *      branchId: // value for 'branchId'
 *   },
 * });
 */
export function useGenerateManageUrlMutation(baseOptions?: Apollo.MutationHookOptions<GenerateManageUrlMutation, GenerateManageUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateManageUrlMutation, GenerateManageUrlMutationVariables>(GenerateManageUrlDocument, options);
      }
export type GenerateManageUrlMutationHookResult = ReturnType<typeof useGenerateManageUrlMutation>;
export type GenerateManageUrlMutationResult = Apollo.MutationResult<GenerateManageUrlMutation>;
export type GenerateManageUrlMutationOptions = Apollo.BaseMutationOptions<GenerateManageUrlMutation, GenerateManageUrlMutationVariables>;
export type GetTariffPlansQueryVariables = Types.Exact<{
  period?: Types.InputMaybe<Types.TariffPeriod>;
}>;


export type GetTariffPlansQuery = { __typename?: 'Query', planPrice: Array<{ __typename?: 'PlanPriceProxy', planId: number, planName: Types.TariffPlan, uah?: number | null, eur?: number | null }> };

export type GetPaidFeaturesQueryVariables = Types.Exact<{
  page?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  itemsPerPage?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  companyId: Types.Scalars['Int']['input'];
}>;


export type GetPaidFeaturesQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', id: number, email?: string | null, company?: { __typename?: 'CompanyProxy', id: number, timeZone?: { __typename?: 'TimeZoneProxy', id: number, name: string } | null, paidFeaturesPaginated: { __typename?: 'PaidFeaturePaginated', currentPage?: number | null, itemsPerPage?: number | null, pageCount?: string | null, totalCount?: number | null, paidFeatures?: Array<{ __typename?: 'PaidFeatureProxy', id: number, name?: Types.Tariff | null, status?: Types.SubscriptionStatus | null, isYearly: boolean, currency?: Types.Currency | null, price: number, subscriptionRegistrationDate?: string | null, dateOfLastPayment: string, paymentOrdersByDate?: Array<{ __typename?: 'PaymentOrderProxy', id: number, planId: number, test: boolean, amount?: number | null, currency?: string | null, createdAt?: string | null, status?: Types.PaymentOrderStatus | null, invoiceUrl?: string | null }> | null, paymentOrder?: { __typename?: 'PaymentOrderProxy', id: number, planId: number, test: boolean, invoiceUrl?: string | null, amount?: number | null, currency?: string | null, status?: Types.PaymentOrderStatus | null, createdAt?: string | null, paymentOrders?: Array<{ __typename?: 'PaymentOrderProxy', id: number, planId: number, invoiceUrl?: string | null, test: boolean }> | null } | null }> | null }, paidFeatures?: Array<{ __typename?: 'PaidFeatureProxy', id: number, name?: Types.Tariff | null, status?: Types.SubscriptionStatus | null, isYearly: boolean, currency?: Types.Currency | null, price: number, subscriptionRegistrationDate?: string | null, dateOfLastPayment: string, paymentOrdersByDate?: Array<{ __typename?: 'PaymentOrderProxy', id: number, planId: number, test: boolean, amount?: number | null, currency?: string | null, createdAt?: string | null, status?: Types.PaymentOrderStatus | null, invoiceUrl?: string | null }> | null, paymentOrder?: { __typename?: 'PaymentOrderProxy', id: number, planId: number, test: boolean, invoiceUrl?: string | null, amount?: number | null, currency?: string | null, status?: Types.PaymentOrderStatus | null, createdAt?: string | null, paymentOrders?: Array<{ __typename?: 'PaymentOrderProxy', id: number, planId: number, invoiceUrl?: string | null }> | null } | null }> | null } | null } | null };

export type GetPaymentStatusQueryVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
  orderId: Types.Scalars['Int']['input'];
}>;


export type GetPaymentStatusQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', id: number, company?: { __typename?: 'CompanyProxy', paymentOrders?: Array<{ __typename?: 'PaymentOrderProxy', status?: Types.PaymentOrderStatus | null, invoiceUrl?: string | null }> | null } | null } | null };

export type GetPlanPriceQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetPlanPriceQuery = { __typename?: 'Query', planPrice: Array<{ __typename?: 'PlanPriceProxy', planId: number, planName: Types.TariffPlan, eur?: number | null, uah?: number | null, usd?: number | null, savingsEur: number, savingsUah?: number | null, savingsUsd?: number | null }> };

export type GeneratePaymentUrlMutationVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
  input: Types.GeneratePaymentUrlInput;
  branchId: Types.Scalars['Int']['input'];
}>;


export type GeneratePaymentUrlMutation = { __typename?: 'Mutation', generatePaymentUrl: string };

export type GenerateManageUrlMutationVariables = Types.Exact<{
  paidFeatureId: Types.Scalars['Int']['input'];
  branchId: Types.Scalars['Int']['input'];
}>;


export type GenerateManageUrlMutation = { __typename?: 'Mutation', generateManageUrl: string };
